export enum SalesforceProductPromotionType {
    MEMBER_PRICE = 'memberprice',
    DISCOUNT_PRICE = 'discountprice',
    SUPER_PRICE = 'superprice',
    MIX_AND_MATCH = 'mixandmatch',
    CHRISTMAS_PRICE = 'christmasprice',
    IMERCO_PRICE = 'imercoprice',
    SPECIAL_PRICE = 'specialprice',
    MULTI_BUY = 'multibuy',
    BASTARD = 'bastard',
    BUNDLE = 'bundle',
}

export enum SalesforceProductPriceType {
    DEFAULT = 'default',
    SALE = 'sale',
    DISABLED = 'disabled',
}

export interface SalesforceProductPrice {
    type?: SalesforceProductPriceType;
    value: string | number;
    label: string;
    schema?: boolean;
    promotype?: SalesforceProductPromotionType;
}

export interface SalesforceProductSpecialPrice {
    id?: string;
    value?: number;
    label?: string;
    promotype?: string;
    retailPrice?: number;
    discountAmount?: number;
    effectivePrice?: number;
    splash?: string;
    basketAmountThreshold?: number;
    splashBelowThreshold?: string;
    splashAboveThreshold?: string;
    amountInBasket?: number;
    staticTileFooterText?: string;
    tileFooterText?: string;
    basketNumberOfProductsThreshold?: number;
    isAmountThreshold?: boolean;
    quantityInBasket?: number;
    campaignElements?: string[];
}

/**
 * TODO(IMC-1671): Drop this once the product and price types are aligned.
 * `SalesforceProductPrice` and `TPrice` are the same shape declared twice, differing only in
 * which enum backs `type` and `promotype`, so neither is assignable to the other. Reading the
 * structural shape accepts both.
 */
export type PriceLike = {
    type?: string;
    value: string | number;
    label?: string;
    schema?: boolean;
    promotype?: string | null;
};
